import { render } from "./BecomeSeller.vue?vue&type=template&id=6e46b03b"
import script from "./BecomeSeller.vue?vue&type=script&lang=js"
export * from "./BecomeSeller.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__